import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { post } from '../../modules/utility';
import { getGlobalClasses } from '../../themes';

import AdminContainer from '../../containers/Admin';
import FormComponent from '../../components/FormComponent';
import FormSelect from '../../components/form/FormSelect';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickerCardPadding: {
			padding: 30,
		},
		pickCardTitleContainer: {
			paddingTop: 10,
			display: 'flex',
			alignContent: 'center',
			alignItems: 'center',
			paddingBottom: 30,
		},
		pickerCardTitle: {
			paddingLeft: 10,
			fontSize: 28,
			color: '#333',
		},
		driverReportIcon: {
			width: 50,
		},
		pickerCardDescriptionLabel: {
			textTransform: 'uppercase',
			color: '#999',
			fontSize: 16,
		},
		pickerCardDescription: {
			fontSize: 18,
		},
		locationRequired: {
			marginTop: 10,
			marginBottom: 10,
			fontSize: 18,
			backgroundColor: '#f7f7f7',
			border: `1px solid #ddd`,
			padding: 15,
		},
		pickerCardButtonContainer: {
			textAlign: 'right',
			paddingTop: 30,
		},
		pickerCardButton: {
			paddingRight: 55,
			paddingLeft: 55,
			fontSize: 18,
		},
	};
};

class CodeLogic extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSavingOpen: false,
			savingStatus: undefined,
		};
	}

	handleOpenFile = () => {
		const { showErrors } = this.props;
		const { codeName } = this.state;
		this.setState({ searching: true });

		post({
			method: 'admin.getCode',
			params: {
				codeName,
			},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return this.setState({
						searching: false,
					});
				}

				console.log(r);
				this.setState({
					searching: false,
					fileString: r.fileString,
				});
			},
		});
	};

	render() {
		const { classes } = this.props;
		const { fileString } = this.state;
		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>View Code Logic</div>

				<Grid container spacing={2}>
					<Grid item xs={12} sm={12}>
						<Paper className={classes.pickerCardPaper}>
							<div className={classes.pickerCardPadding}>
								<div>
									<div className={classes.locationRequired}>
										Pick the code logic file to view the TMW logic that is run server side. Note one
										file may reference another.
									</div>

									<FormSelect
										{...this.setForm('codeName', 'Code logic file to view', true)}
										label={'Code Logic File'}
										options={[{ display: 'Update Stop Logic', value: 'updateStop' }]}
									/>

									<div className={classes.pickerCardButtonContainer}>
										<Button
											variant="contained"
											color="primary"
											aria-label="Add"
											size="large"
											className={classes.pickerCardButton}
											onClick={this.handleOpenFile}
										>
											View
										</Button>
									</div>
								</div>
							</div>
						</Paper>
						{!!fileString && (
							<Paper style={{ fontSize: '80%' }}>
								<SyntaxHighlighter language="javascript" style={dracula}>
									{fileString}
								</SyntaxHighlighter>
							</Paper>
						)}
					</Grid>
				</Grid>
			</Fragment>
		);
	}
}

CodeLogic.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
	getBrowserAuthCode: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), AdminContainer])(CodeLogic);
